module.exports = __webpack_public_path__ + "18b38a5f9235b08d4bb1e5607c0dc366.MP3";